'use strict';

window.addEventListener('load', initMenu, false);

//script vars
var defaultMenuClass;

function initMenu() {
	defaultMenuClass = document.getElementById('wrapper_header').getAttribute('class');
	document.getElementById('menu').addEventListener('click', menuOnClick, false);

	var hoofdMenuElement = document.getElementById('hoofdnavigatie');

	var aElements = hoofdMenuElement.getElementsByTagName('a');
	for (var i = 0; i < aElements.length; i++) {
		if (aElements[i].getAttribute('href').match(/^\/?#/)) {
			aElements[i].addEventListener('click', menuOnClick, false);
		}
	}
}

function menuOnClick(e) {
	if (!e) var e = window.event;

	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	}

	if (document.getElementById('wrapper_header').getAttribute('class') == defaultMenuClass + ' active') {
		document.getElementById('wrapper_header').setAttribute('class', defaultMenuClass);
		document.body.classList.remove('nav-active');
	} else if (document.getElementById('wrapper_header').getAttribute('class') == 'active') {
		document.getElementById('wrapper_header').removeAttribute('class');
		document.body.classList.remove('nav-active');
	} else if (target == document.getElementById('menu')) {
		if (defaultMenuClass) {
			document.getElementById('wrapper_header').setAttribute('class', defaultMenuClass + ' active');
			document.body.classList.add('nav-active');
		} else {
			document.getElementById('wrapper_header').setAttribute('class', 'active');
			document.body.classList.add('nav-active');
		}
	}
}